import { setURL } from '@/api/apiUtil'

export default {
  // 取得社區列表
  getCommunities: {
    url: setURL('/community'),
    method: 'get'
  },
  // 取得拆機清單
  getDelSchedule: {
    url: '/WebAPI/api/getDelSchedule',
    method: 'get'
  },
}
